module.exports = __webpack_public_path__ + "static/media/gift-card.526ffe4c.svg";